import QuestionFooter from './questionFooter'

export { QuestionFooter }
